// extracted by mini-css-extract-plugin
module.exports = {"rentalTitle":"oH","boxArtWrapper":"oI","rentalArtwork":"oJ","rentalName":"oK"};